export default __webpack_public_path__ + "media/src/assets/images/on-time-1bb2764e4c81b4443d72796f38e76878.svg";